export default __webpack_public_path__ + "static/media/093-right-arrow-4.e2e71c9b.png";